/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type ReactNode } from 'react';

import { cssMap, jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	row: {
		marginBlock: token('space.400'),
	},
});

export const Column = ({ children, size = 1 }: { children: ReactNode; size: number }) => (
	<div style={{ flex: size }}>{children}</div>
);

export const Row = ({ children }: { children: ReactNode }) => (
	<Inline space="space.400" xcss={styles.row} alignBlock="center">
		{children}
	</Inline>
);
